import React from 'react';
import { Link } from 'react-router-dom';
import MainLayout from '../components/Layout/MainLayout.js';

const NotFoundPage = () => {
    return (
        <MainLayout>
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="max-w-xl mx-auto py-16 sm:py-24">
                    <div className="text-center">
                        <p className="text-sm font-semibold text-amber-800 uppercase tracking-wide">
                            404 fejl
                        </p>
                        <h1 className="mt-2 text-4xl font-bold font-montserrat text-gray-900 tracking-tight sm:text-5xl">
                            Siden blev ikke fundet
                        </h1>
                        <p className="mt-4 text-lg text-gray-500">
                            Beklager, men vi kunne ikke finde den side du ledte efter.
                        </p>
                        <div className="mt-6">
                            <Link
                                to="/"
                                className="text-base font-medium text-amber-800 hover:text-amber-900"
                            >
                                Gå til forsiden
                                <span aria-hidden="true"> &rarr;</span>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </MainLayout>
    );
};

export default NotFoundPage;